<template>
  <j-modal :title="displayTitle" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('热线人员名称')" prop="hotlineStaffName">
                <a-input v-model="model.hotlineStaffName" :placeholder="$t('请输入热线人员名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('分机号')" prop="hardwareDevicesName">
                <a-input v-model="model.hardwareDevicesName" :placeholder="$t('请输入分机号')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('系统登录账号')" prop="sysUserName">
                <a-select v-model="model.sysUserName" :placeholder="$t('请选择系统登录账号')">
                  <a-select-option v-for="item in candidateUsersList" :value="item.username">{{item.username}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  export default {
    name: 'modal',
    components: {
      JImageUpload
    },
    data() {
      let validateRemark = (rule, value, callback) => {
        if(this.model.audit == 0){
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请输入备注')));
          }
        }else{
          callback();
        }
      };
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          userList: "/sys/user/list",
          add: '/jeecg-hotline/hotlinestaff/hotlineStaffMessage/add',
          edit: '/jeecg-hotline/hotlinestaff/hotlineStaffMessage/edit',
        },
        candidateUsersList: [],
        oldMeter:{},
        newMeter:{},
        userInfo:{},
      }
    },
    watch:{},
    // i18n：校验规则/标题使用 computed 以响应语言切换
    computed: {
      displayTitle() {
        return this.title ? this.$t(this.title) : '';
      },
      validatorRules() {
        return {
          hotlineStaffName:{ required: true,message: this.$t('请输入热线人员名称'), trigger: 'input' },
          hardwareDevicesName:{ required: true,message: this.$t('请输入硬件设备名称'), trigger: 'input' },
          sysUserName:{ required: true,message: this.$t('请选择系统登录账号'), trigger: 'change' },
        }
      },
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{status:1,pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      init(row,type){
        this.visible = true;
        if(type == 'add'){
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }else if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else{
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }
        this.model = Object.assign({},row);
        this.getUserList();
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            if(that.model.id){
              httpurl+=this.url.edit;
            }else{
              httpurl+=this.url.add;
            }
            let params = that.model;
            postAction(httpurl,params).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
          }
        })
      },
    }
  }
</script>